import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';

const SkipNavigation = ({ links }) => {
  const defaultLinks = [
    { href: "#content", label: "본문 바로가기" },
    { href: "#navigation", label: "주메뉴 바로가기" }
  ];
  const skipLinks = links || defaultLinks;
  const SkipNavigationRef = useRef(null);
  return /* @__PURE__ */ jsx("div", { className: "skip-navigation", ref: SkipNavigationRef, children: skipLinks.map(
    (link, index) => /* @__PURE__ */ jsx("a", { href: link.href, className: "skip-item-link", children: link.label }, index)
  ) });
};

export { SkipNavigation };
